
import packageJson from '../../package.json';

export default function Footer(props){



    const version = packageJson.name+" v."+packageJson.version

    return (
        <div className={"footer"}>
            {version}
        </div>
    )
}